export default __webpack_public_path__ + "static/media/healthmo.a2908181.png";